import qs from 'qs'

const fields = [
  'slug',
  'locale',
  'title',
  'secondaryTitle',
  'dateStart',
  'dateEnd',
]

export const queryExhibitionEntryDocumentationBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        ...queryFragmentSeo,
        images: {
          fields: '*',
        },
        localizations: {
          fields: fields
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `exhibition-entries?${query}`
}
